import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import {
  getAdAccount,
  putAdAccountOff,
  putAdAccountOn,
} from '../../api/axios/crux/account'
import { setLnbAccount } from '../lnb/lnbSlice'

export const AD_ACCOUNT_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  UNAUTHORIZED: 'unauthorized',
}

export const fetchAdAccount = createAsyncThunk(
  'account/fetchAdAccount',
  async (adAccountId, { rejectWithValue }) => {
    try {
      const { data } = await getAdAccount(adAccountId)
      return data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const refetchAdAccount = createAsyncThunk(
  'account/refetchAdAccount',
  async (noArgs, { dispatch, getState, rejectWithValue }) => {
    try {
      const adAccountId = getState().account.current.id
      const { data } = await getAdAccount(adAccountId)
      dispatch(setLnbAccount(data))
      return data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const modifyAdAccountOnOff = createAsyncThunk(
  'account/modifyAdAccountOnOff',
  async ({ adAccountId, state }, { dispatch }) => {
    const { data } =
      state === 'OFF'
        ? await putAdAccountOff(adAccountId)
        : await putAdAccountOn(adAccountId)
    dispatch(setLnbAccount(data))
    return data
  }
)

const initialState = {
  status: AD_ACCOUNT_STATUS.IDLE,
  current: undefined,
  isLoading: false,
}

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchAdAccount.pending, state => {
      state.status = AD_ACCOUNT_STATUS.PENDING
    })
    builder.addCase(fetchAdAccount.fulfilled, (state, { payload }) => {
      state.current = payload
      state.status = AD_ACCOUNT_STATUS.SUCCESS
    })
    builder.addCase(fetchAdAccount.rejected, state => {
      state.status = AD_ACCOUNT_STATUS.UNAUTHORIZED
    })
    builder.addCase(refetchAdAccount.fulfilled, (state, { payload }) => {
      state.current = payload
    })

    builder.addCase(modifyAdAccountOnOff.pending, state => {
      state.isLoading = true
    })
    builder.addCase(modifyAdAccountOnOff.fulfilled, (state, { payload }) => {
      if (state?.current) {
        state.current.userConfig = payload.userConfig
        state.current.status = payload.status
        state.current.version = payload.version
        state.current.lastModifiedDate = payload.lastModifiedDate
      }
      state.isLoading = false
    })
    builder.addCase(modifyAdAccountOnOff.rejected, state => {
      state.isLoading = false
    })
  },
})
export const { reset } = accountSlice.actions
export default accountSlice.reducer
